import { useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import CreateButton from "../../../components/ToolBar/Buttons/CreateButton";
import RecordPerPage from "../../../components/ToolBar/Dropdown/RecordPerPage";
import ContentBox from "../../../components/ContentBox/ContentBox";
import Listing from "./components/Listing/Listing";
import {
  setPerPageSize,
  setDetails,
  deleteRecord,
  fetchList,
  details,
} from "./utils/slice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import AddComponent from "./components/Form/AddComponent";
import EditComponent from "./components/Form/EditComponent";
import { CareerGroupBreadcrumb } from "../../../config/BreadcrumbConfig";
import { toUpperCaseWithUnderscore } from "../../../utils/commonFunctions";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/hooks";
import { CONSTANT } from "../../../config/Constant";
import { setEditLoading } from "../../../store/CommonSlice";

const moduleInfo = {
  title: "Career Group",
  permissionKeyPrefix: toUpperCaseWithUnderscore("Career Group"),
};

/**
 * Renders the CareerGroup component.
 *
 * @return {ReactElement} The rendered CareerGroup component.
 */
const CareerGroup: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { perPage } = useAppSelector((state) => state.careerGroup);
  const [isCreateVisible, setIsCreateVisible] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [deleteValue, setDeleteValue] = useState<any>();

  useEffect(() => {
    dispatch(fetchList()).catch((error: any) => error);
  }, []);


  const getDetails = (data: any, type: string) => {
      if (type === CONSTANT.DRAWER_TYPE.EDIT) {
        dispatch(setEditLoading([true, data.id]));
      }
  
      dispatch(details(data.id))
        .then((data: any) => {
          if (type === CONSTANT.DRAWER_TYPE.EDIT) {
            setEditDrawer(true);
            dispatch(setEditLoading([false, data.id]));
          }
        })
        .catch((error: any) => error);
    };

  return (
    <>
      <ToolBar breadcrumbs={CareerGroupBreadcrumb}>
        <CreateButton
          action={() => setIsCreateVisible(true)}
          permissionKey={`${moduleInfo.permissionKeyPrefix}_CREATE`}
        />
        <RecordPerPage
          perPage={perPage}
          onChange={(perPageSize: number) => {
            dispatch(setPerPageSize(perPageSize));
          }}
        />
      </ToolBar>
      <ContentBox>
        <Listing
          moduleInfo={moduleInfo}
          handleEditClick={(data: any) => {
            getDetails(data, CONSTANT.DRAWER_TYPE.EDIT);
            // dispatch(setDetails(data));
            // setEditDrawer(true);
          }}
          handleDeleteClick={setDeleteValue}
        />
        <AddComponent
          titleName={moduleInfo.title}
          open={isCreateVisible}
          close={() => setIsCreateVisible(false)}
        />
        <EditComponent
          titleName={moduleInfo.title}
          open={editDrawer}
          close={() => dispatch(setDetails(null)) && setEditDrawer(false)}
        />
        <DeleteModal
          title={moduleInfo.title}
          deleteValues={deleteValue}
          callApi={deleteRecord}
          close={() => setDeleteValue(null)}
        />
      </ContentBox>
    </>
  );
};

export default CareerGroup;
